// extracted by mini-css-extract-plugin
export default {"container":"AuthenticationLayout_container__GD2BU"};